<script>

import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';
import config from '../../common/genericPanelConf';
import Service from '@/services/planning';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
// import GenericDateTimeMaskV2 from '../../components/generic/GenericDateTimeMaskV2.vue';
import TheoreticalLotsGrid from '@/components/planning/TheoreticalLotsGrid.vue';
import GenericCustomAutocompleteV2 from '@/components/generic/GenericCustomAutocompleteV2.vue';

export default {
    components: 
        {
            GenericCustomMasterDataAutocompleteV2
            ,ResponsiveButton
            ,TheoreticalLotsGrid
            // ,GenericCustomAutocompleteV2
            // ,GenericDateTimeMaskV2
        },
    props: [],
    data() {
        return {
            idVesselSummaryHeader: null,
            filters: {
                weekNumber: null,
                year: null
            },
            saveFilters: {
                startDate:Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
                endDate: Utils.setLastDayOfMonth(Utils.formatDatePlusMonths(new Date(), 1))
            },
            showImportDialog: false,
            showImportPreview: false,
            showVesselSummary: false,
            showLinkMovementInstructionDialog: false,
            confirmImportDialog: false,
            weekNumber: null,
            data: [],
            vesselSummaryData: [],
            selectedMonth: null,
            vesselSummarySelectedMonth: null,
            months: [],
            monthsConfirmed: {},
            vesselSummary: {},
            linkDto: {
                idTheoreticalLot: null,
                voyageNumber: null
            },

            voyagesSelectedMonth: null,
            voyages: [],
            showVoyages: true,
            searchFilters: {
                startDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
                ownerCompanyId: null
            },
            publishDialogVisible: false,
            publishItem: {},
            changeStatusDialogVisible: false,
            changeStatusItem: {
                id: null,
                status: ""
            },
            statusList: [ 'ACTUAL', 'NOT_CONFIRMED', 'CONFIRMED', 'DELETED'],

            updateOperationalLaycanDialogVisible: false,
            updateOperationalLaycanItem: {
                id: null,
                operationalLaycanStartDate: null,
                operationalLaycanEndDate: null
            }
        }
    },
    created() {
        this.$store.dispatch('security/setNavbarTitle', 'vesselSummary.page_title');
    },
    mounted() {
        this.loadVoyages();
    },
    watch: {
        selectedMonth(){
            this.data = [];
            if(this.selectedMonth){
                let d = this.months.filter(m => m.name == this.selectedMonth);
                this.data = d[0];
                for(let i=0; i<this.data.voyagesImport.length; i++){
                    this.data.voyagesImport[i].laycanStartDate = this.data.voyagesImport[i].laycanStartDate ? new Date(Utils.dateToCurrentTimeZone(this.data.voyagesImport[i].laycanStartDate)) : null;
                    this.data.voyagesImport[i].laycanEndDate = this.data.voyagesImport[i].laycanEndDate ? new Date(Utils.dateToCurrentTimeZone(this.data.voyagesImport[i].laycanEndDate)) : null;
                }

                for(let i=0; i<this.data.voyagesExport.length; i++){
                    this.data.voyagesExport[i].laycanStartDate = this.data.voyagesExport[i].laycanStartDate ? new Date(Utils.dateToCurrentTimeZone(this.data.voyagesExport[i].laycanStartDate)) : null;
                    this.data.voyagesExport[i].laycanEndDate = this.data.voyagesExport[i].laycanEndDate ? new Date(Utils.dateToCurrentTimeZone(this.data.voyagesExport[i].laycanEndDate)) : null;
                }
            }
        },
        voyagesSelectedMonth(){
            this.vesselSummaryData = [];
            if(this.voyagesSelectedMonth && this.voyages){
                let d = this.voyages.filter(m => m.monthReference == this.voyagesSelectedMonth);
                if(d && d.length > 0){
                    this.vesselSummaryData = d[0];
                    for(let i=0; i<this.vesselSummaryData.voyagesImport.length; i++){
                        this.vesselSummaryData.voyagesImport[i].laycanStartDate = this.vesselSummaryData.voyagesImport[i].laycanStartDate ? new Date(Utils.dateToCurrentTimeZone(this.vesselSummaryData.voyagesImport[i].laycanStartDate)) : null;
                        this.vesselSummaryData.voyagesImport[i].laycanEndDate = this.vesselSummaryData.voyagesImport[i].laycanEndDate ? new Date(Utils.dateToCurrentTimeZone(this.vesselSummaryData.voyagesImport[i].laycanEndDate)) : null;
                    }

                    for(let i=0; i<this.vesselSummaryData.voyagesExport.length; i++){
                        this.vesselSummaryData.voyagesExport[i].laycanStartDate = this.vesselSummaryData.voyagesExport[i].laycanStartDate ? new Date(Utils.dateToCurrentTimeZone(this.vesselSummaryData.voyagesExport[i].laycanStartDate)) : null;
                        this.vesselSummaryData.voyagesExport[i].laycanEndDate = this.vesselSummaryData.voyagesExport[i].laycanEndDate ? new Date(Utils.dateToCurrentTimeZone(this.vesselSummaryData.voyagesExport[i].laycanEndDate)) : null;
                    }
                }
            }
        },
        vesselSummarySelectedMonth(){
            this.vesselSummaryData = [];
            if(this.vesselSummarySelectedMonth && this.vesselSummary.months){
                let d = this.vesselSummary.months.filter(m => m.monthReference == this.vesselSummarySelectedMonth);
                this.vesselSummaryData = d[0];
                for(let i=0; i<this.vesselSummaryData.voyagesImport.length; i++){
                    this.vesselSummaryData.voyagesImport[i].laycanStartDate = this.vesselSummaryData.voyagesImport[i].laycanStartDate ? new Date(Utils.dateToCurrentTimeZone(this.vesselSummaryData.voyagesImport[i].laycanStartDate)) : null;
                    this.vesselSummaryData.voyagesImport[i].laycanEndDate = this.vesselSummaryData.voyagesImport[i].laycanEndDate ? new Date(Utils.dateToCurrentTimeZone(this.vesselSummaryData.voyagesImport[i].laycanEndDate)) : null;
                }

                for(let i=0; i<this.vesselSummaryData.voyagesExport.length; i++){
                    this.vesselSummaryData.voyagesExport[i].laycanStartDate = this.vesselSummaryData.voyagesExport[i].laycanStartDate ? new Date(Utils.dateToCurrentTimeZone(this.vesselSummaryData.voyagesExport[i].laycanStartDate)) : null;
                    this.vesselSummaryData.voyagesExport[i].laycanEndDate = this.vesselSummaryData.voyagesExport[i].laycanEndDate ? new Date(Utils.dateToCurrentTimeZone(this.vesselSummaryData.voyagesExport[i].laycanEndDate)) : null;
                }
            }
        }
    },
    computed: {
        constants() {
            return CommonConstants; 
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
        weekNumbers(){
            let list = [];
            for(let w=1; w<=53; w++){
                list.push(w);
            }
            return list;
        },

    },
    methods: {
        async uploaderResponseMethod(file){

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
            });
            const base64 = await toBase64(file.files[0]);
            let formData = {
                weekNumber: this.filters.weekNumber,
                year: this.filters.year,
                fileContent: base64
            }

            this.selectedMonth= null;
            this.months = null;
            this.$store.dispatch("generic/setLoading", true);
            Service.importVesselSummaryFromFile(formData, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.showImportDialog = false;
                    this.showVesselSummary = false;
                    this.showImportPreview = true;
                    this.months = response.data;
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        rowClass(data) {
            if(data.status == "CONFIRMED"){
                return "bg-confirmed";
            }else if (data.status == "NOT_CONFIRMED"){
                return "bg-not-confirmed";
            }else if (data.status == "DELETED"){
                return "bg-deleted";
            }
        },
        onCellEditComplete(e){
            if(e.value != e.newValue){
                if(e.data.movementDirection == 'EXPORT'){
                    this.data.voyagesExport[e.index][e.field] = e.newValue;
                    this.data.voyagesExport[e.index][e.field + '_dirty'] = true;
                }else{
                    this.data.voyagesImport[e.index][e.field] = e.newValue;
                    this.data.voyagesImport[e.index][e.field + '_dirty'] = true;
                }
            }
        },
        isVoyageEditable(data){
            return data.status != 'ACTUAL' && data.status != 'DELETED'
        },
        savePreview(){
            this.monthsConfirmed = [];
            for(let i=0; i<this.months.length; i++){
                this.monthsConfirmed[i] = true;
            }
            this.confirmImportDialog = true;
        },
        confirmSavePreview(){
        
            let body = {
                weekNumber: this.filters.weekNumber,
                year: this.filters.year,
                startDate: this.saveFilters.startDate,
                endDate: this.saveFilters.endDate,
                data: this.months
            }
            this.$store.dispatch("generic/setLoading", true);
            Service.saveVesselSummaryPreview(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.confirmImportDialog = false;
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        loadVesselSummary(){
            this.showImportPreview = false;
            this.showVesselSummary = true;
            this.showVoyages = false;
            this.resetData();
            let body = {
                weekNumber: this.filters.weekNumber,
                year: this.filters.year
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.getVesselSummaryHeader(this.idVesselSummaryHeader, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.vesselSummary = response.data;
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        loadVoyages(){
            this.showImportPreview = false;
            this.showVesselSummary = false;
            this.showVoyages = true;
            this.resetData();
            let body = {
                startDate: Utils.formatDateForAPI(this.searchFilters.startDate),
                ownerCompanyId: this.searchFilters.ownerCompanyId
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.getVesselSummary(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.voyages = response.data;
                    this.voyagesSelectedMonth = response.data && response.data.length > 0 ? response.data[0].monthReference : null
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        resetData(){
            this.vesselSummary = null;
            this.vesselSummarySelectedMonth = null;
            this.vesselSummaryData = [];

            this.voyagesSelectedMonth = null;
            this.voyages = [];
        },
        saveVesselSummary(){
            this.$store.dispatch("generic/setLoading", true);
            Service.saveVesselSummaryDetails(this.vesselSummary, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.vesselSummary = response.data;
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    this.loadVesselSummary();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        openLinkMovementInstructions(data){
            this.linkDto.idTheoreticalLot = data.idPlanningVesselSummaryVoyage;
            this.linkDto.voyageNumber = null;
            this.showLinkMovementInstructionDialog = true;
        },
        openLinkMovementInstructionsSaved(data){
            this.linkDto.idTheoreticalLot = data.id;
            this.linkDto.voyageNumber = null;
            this.showLinkMovementInstructionDialog = true;
        },
        confirmLinkMovementInstructions(){
            this.$store.dispatch("generic/setLoading", true);
            Service.linkMovementInstruction(this.linkDto, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.linkDto = {
                        idTheoreticalLot: null,
                        voyageNumber: null
                    };
                    this.showLinkMovementInstructionDialog = false;
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        exportVessel(){
            this.$store.dispatch("generic/setLoading", true);

            Service.exportVesselSummary({id: this.vesselSummary.id}, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
                
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    let fileName = `Vessel Summary ${this.vesselSummary.weekNumber} ${this.vesselSummary.year}.xlsx`
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        exportVesselByDate(){
            this.$store.dispatch("generic/setLoading", true);
            let body = {
                startDate: Utils.formatDateForAPI(this.searchFilters.startDate),
                ownerCompanyId: this.searchFilters.ownerCompanyId
            };
            Service.exportVesselSummaryByDate(body, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
                
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    let fileName = `Vessel Summary.xlsx`
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        publishVessel(){
            this.publishItem = {
                startDate: this.searchFilters.startDate,
                week: null,
                year: null
            };
            this.publishDialogVisible = true;
        },
        publishVesselSummary(){
            let body = {
                startDate: Utils.formatDateForAPI(this.publishItem.startDate),
                week: this.publishItem.week,
                year: this.publishItem.year
            }
            this.$store.dispatch("generic/setLoading", true);
            Service.publishVesselSummary(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.publishDialogVisible = false;
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        openChangeStatus(data){
            this.changeStatusItem = {
                id: data.id,
                status: data.status
            };
            this.changeStatusDialogVisible = true;
        },
        confirmChangeStatus(){
            this.$store.dispatch("generic/setLoading", true);
            Service.changeTheoreticalLotStatus(this.changeStatusItem, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.changeStatusDialogVisible = false;
                    this.loadVoyages();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        alignActualInfo(data){
            this.$confirm.require({
            message: this.$t('messages.generic_confirm_message'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),

            accept: () => {                  
            
            this.$store.dispatch("generic/setLoading", true);
            Service.getAlignActualInfo(data.idMovementInstructionHeader, 
                response => {   
                this.$store.dispatch("generic/setLoading", false);      
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
                })
            },
            reject: () => {
                this.$confirm.close();
            }
        });
        },

        showAlignInfoButton(data){
            return data.idMovementInstructionHeader != null;
        },
        getStatusLabel(data){
            if(data.actualQuantity){
                return "CLEARED";
            }
            if(data.mooringDate && new Date(data.mooringDate) < new Date()){
                return "LOADING";
            }
            if(data.status == 'DELETED'){
                return 'DELETED';
            }
            return "PLANNED"
        },
        getStatusSeverity(data){
            let status = this.getStatusLabel(data);
            switch(status){
                case "CLEARED":
                    return 'success';
                case "LOADING":
                    return 'info';
                case "DELETED":
                        return 'danger';
                default:
                    return 'warning';
            }
        },
        formatLaycan(data){
            try{
                if(data.operationalLaycanStartDate && data.operationalLaycanEndDate){
                    let startDate = new Date(Utils.dateToCurrentTimeZone(data.operationalLaycanStartDate));
                    let endDate = new Date(Utils.dateToCurrentTimeZone(data.operationalLaycanEndDate));

                    let laycanString = "";

                    let startDay = startDate.getDate();
                    laycanString += startDay < 10 ? '0' + startDay : startDay;
                    laycanString +='-';
                    let endDay = endDate.getDate();
                    laycanString += endDay < 10 ? '0' + endDay : endDay;
                    laycanString +='.';
                    let endMonth = endDate.getMonth() + 1;
                    laycanString += endMonth < 10 ? '0' + endMonth : endMonth;
                    return laycanString;
                }
            }catch{
                return "";
            }
        },
        openUpdateOperationalLaycan(data){
            this.updateOperationalLaycanItem = {
                id: data.id,
                operationalLaycanStartDate: data.operationalLaycanStartDate != null ? Utils.dateToCurrentTimeZone(data.operationalLaycanStartDate) : null,
                operationalLaycanEndDate: data.operationalLaycanEndDate != null ? Utils.dateToCurrentTimeZone(data.operationalLaycanEndDate) : null
            }
            this.updateOperationalLaycanDialogVisible = true;
        },
        updateOperationalLaycan(){
            this.$store.dispatch("generic/setLoading", true);
            let body = {
                id: this.updateOperationalLaycanItem.id,
                operationalLaycanStartDate: this.updateOperationalLaycanItem.operationalLaycanStartDate != null ? Utils.formatDateForAPI(this.updateOperationalLaycanItem.operationalLaycanStartDate) : null,
                operationalLaycanEndDate: this.updateOperationalLaycanItem.operationalLaycanEndDate != null ? Utils.formatDateForAPI(this.updateOperationalLaycanItem.operationalLaycanEndDate) : null
            }
            Service.updateOperationalLaycan(body, 
                response => {   
                this.$store.dispatch("generic/setLoading", false);      
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    this.updateOperationalLaycanDialogVisible = false;
                    this.loadVoyages();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        }
    },
}

</script>

<template>
    <main>

        <Dialog v-model:visible="updateOperationalLaycanDialogVisible" :style="{ width: '350px' }" modal>
            <div class="grid">
                <div class="col-12 lg:col-6">
                    <label>{{$t('startDate')}}</label>
                    <Calendar
                        :class="{'p-inputtext-sm w-full': true}"
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        dateFormat="dd/mm/yy"
                        :showTime="false"
                        v-model="updateOperationalLaycanItem.operationalLaycanStartDate"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>
                <div class="col-12 lg:col-6">
                    <label>{{$t('endDate')}}</label>
                    <Calendar
                        :class="{'p-inputtext-sm w-full': true}"
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        dateFormat="dd/mm/yy"
                        :showTime="false"
                        v-model="updateOperationalLaycanItem.operationalLaycanEndDate"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>
            </div>
            <div class="flex justify-content-end gap-2">
                <Button type="button" class="m-2" :label="$t('btn.cancel')" severity="secondary" @click="updateOperationalLaycanDialogVisible = false"></Button>
                <Button type="button" class="m-2" :label="$t('btn.save')" icon="pi pi-save" @click="updateOperationalLaycan"></Button>
            </div>
        </Dialog>

        <Dialog v-model:visible="showLinkMovementInstructionDialog" modal :style="{ width: '85vw'}">
            <TheoreticalLotsGrid :showCreate="true" :showLink="false" :id="linkDto.idTheoreticalLot" :hideFilters="true"/>

            <!-- <div class="grid">
                <div class="col-12 lg:col-6">
                    <label for="voyageN">{{$t('movementInstructions.voyageNumber')}}</label>
                    <InputText id="voyageN" class="w-full" v-model="linkDto.voyageNumber" />
                </div>
            </div>
            <div class="flex justify-content-end gap-2">
                <Button type="button" class="m-2" label="Cancel" severity="secondary" @click="showLinkMovementInstructionDialog = false"></Button>
                <Button type="button" class="m-2" label="Save" icon="pi pi-save" @click="confirmLinkMovementInstructions"></Button>
            </div> -->
        </Dialog>

        <Dialog v-model:visible="showImportDialog" :style="{ width: '350px' }" modal>
            <div class="grid">
                <div class="col-12 lg:col-6">
                    <label for="week">{{$t('vesselSummary.weekNumber')}}</label>
                    <InputText type="number" id="week" class="w-full" :minFractionDigits="0" :min="1" :max="54" :maxFractionDigits="0" v-model="filters.weekNumber" />
                </div>
                <div class="col-12 lg:col-6">
                    <label for="year">{{$t('vesselSummary.year')}}</label>
                    <InputText type="number" id="year" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" :min="2023" :max="9999" v-model="filters.year" />
                </div>
                <div class="col-12">
                    <FileUpload name="uploaded[]" :customUpload="true" @uploader="uploaderResponseMethod" :previewWidth="0" :fileLimit="1" :multiple="false" />      
                </div>
            </div>
        </Dialog>

        <Dialog v-model:visible="confirmImportDialog" :style="{ width: '350px' }" modal>
            <div class="grid">
                <div class="col-12 lg:col-6">
                    <label for="week">{{$t('vesselSummary.weekNumber')}}</label>
                    <InputText type="number" id="week" class="w-full" :minFractionDigits="0" :min="1" :max="54" :maxFractionDigits="0" v-model="filters.weekNumber" />
                </div>
                <div class="col-12 lg:col-6">
                    <label for="year">{{$t('vesselSummary.year')}}</label>
                    <InputText type="number" id="year" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" :min="2023" :max="9999" v-model="filters.year" />
                </div>
                <div class="col-12 lg:col-6 field">
                  <label for="startDate">{{$t('startDate')}}</label>
                  <Calendar 
                    :placeholder="constants.DATE_PLACEHOLDER_POINT"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="true" :hideOnDateTimeSelect="true"
                    :disabled="readOnly"
                    id="startDate" 
                    v-model="saveFilters.startDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                    :class="{'w-full p-inputtext-sm mt-1 ': true}" />
              </div>
              <div class="col-12 lg:col-6 field">
                  <label for="endDate" >{{$t('endDate')}}</label>
                  <Calendar 
                    :placeholder="constants.DATE_PLACEHOLDER_POINT"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="true" :hideOnDateTimeSelect="true"
                    :disabled="readOnly"
                    id="endDate" 
                    v-model="saveFilters.endDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                    :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                </div>
            </div>
            <div class="flex justify-content-end gap-2">
                <Button type="button" class="m-2" label="Cancel" severity="secondary" @click="confirmImportDialog = false"></Button>
                <Button type="button" class="m-2" label="Save" icon="pi pi-save" @click="confirmSavePreview"></Button>
            </div>
        </Dialog>

        <Dialog v-model:visible="publishDialogVisible" modal>
        <div class="grid">
            <div class="col-12 lg:col-6">
                <label>{{$t('DailyProfiles.startDate')}}</label>
                <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    view="month" dateFormat="mm/yy"
                    :showTime="false"
                    v-model="publishItem.startDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <div class="col-12 lg:col-6">
                    <label for="week">{{$t('vesselSummary.weekNumber')}}</label>
                    <InputText type="number" id="week" class="w-full" :minFractionDigits="0" :min="1" :max="54" :maxFractionDigits="0" v-model="publishItem.week" />
                </div>
                <div class="col-12 lg:col-6">
                    <label for="year">{{$t('vesselSummary.year')}}</label>
                    <InputText type="number" id="year" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" :min="2023" :max="9999" v-model="publishItem.year" />
                </div>
        </div>
        
        <div class="flex justify-content-end gap-2">
            <Button type="button" class="m-2" :label="$t('btn.cancel')" severity="secondary" @click="publishDialogVisible = false"></Button>
            <Button type="button" class="m-2" :label="$t('btn.save')" icon="pi pi-save" @click="publishVesselSummary"></Button>
        </div>
    
        </Dialog>

        

        <Dialog v-model:visible="changeStatusDialogVisible" modal>
            <div class="grid">
                <div class="col-12">
                    <label>{{$t('status')}}</label>
                    <Dropdown
                        v-model="changeStatusItem.status"
                        :options="statusList"
                        class="w-full p-inputtext-sm" />
                </div>
            </div>
            
            <div class="flex justify-content-end gap-2">
                <Button type="button" class="m-2" :label="$t('btn.cancel')" severity="secondary" @click="changeStatusDialogVisible = false"></Button>
                <Button type="button" class="m-2" :label="$t('btn.save')" icon="pi pi-save" @click="confirmChangeStatus"></Button>
            </div>
        
        </Dialog>

        <div class="grid">
            <div class="col-12 lg:col-2">
                <label>{{$t('DailyProfiles.startDate')}}</label>
                <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    view="month" dateFormat="mm/yy"
                    :showTime="false"
                    v-model="searchFilters.startDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <div class="col-12 lg:col-2">
                <label for="plant">{{$t('company.fk')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    field="label"
                    :name="'registry-company'"
                    v-model="searchFilters.ownerCompanyId"
                    api="masterdata/company-combo?getOnlyValid=true&getOnlyCompulsoryStockEnabled=true"
                    :format="{ label: 'description', value: 'id' }"
                    :class="{'p-inputtext-sm w-full': true}" />
            </div>
            <div class="p-4">
                <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" @click="loadVoyages" class="p-button-sm p-button-outlined m-3" />
            </div>
            <div class="col-12 lg:col-2" v-if="!uiPermissions('VesselSummaryPublishedVersion').isHidden">
                <label for="week">{{$t('vesselSummary.lastVersions')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    :name="'idVesselSummaryHeader'"
                    v-model="idVesselSummaryHeader"
                    :changeFn="loadVesselSummary"
                    :api="'vessel-summary/header-combo'"/>
            </div>
            <div class="p-4">
                <ResponsiveButton :label="$t('btn.import')" icon="pi pi-file" @click="showImportDialog = true" class="p-button-sm p-button-outlined m-3" 
                v-if="!uiPermissions('ImportVesselSummaryFromExcelBtn').isHidden"/>
            </div>

            <div class="col-12" v-if="showImportPreview">
                <Dropdown v-model="selectedMonth" :options="months" optionValue="name" optionLabel="name" placeholder="Select a Month" class="w-full md:w-14rem"/>
                <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" @click="savePreview" class="p-button-sm p-button-outlined m-1" />
                <TabView>
                    <TabPanel header="Export">
                        <DataTable :value="data.voyagesExport" scrollable :responsiveLayout="'scroll'" breakpoint="960px" rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                            sortField="movementDirection" :sortOrder="1" :rowClass="rowClass" editMode="cell" @cell-edit-complete="onCellEditComplete" size="small">
                        
                            <Column field="family" :header="$t('vesselSummary.family')">
                                <template #body="{ data, field }">
                                    <span>
                                        {{ data[field] }}
                                        <Tag severity="warning" value="Modified" v-if="data[field + '_dirty']" />
                                    </span>
                                </template>
                            </Column>
                            <Column field="cluster" :header="$t('vesselSummary.cluster')" style="width: 150px;">
                                <template #body="{ data, field }">
                                    <InputText v-model="data[field]" autofocus class="w-full" v-tooltip.top="data[field]" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            <Column field="product" :header="$t('vesselSummary.product')" style="width: 150px;">
                                <template #body="{ data, field }">
                                    <InputText v-model="data[field]" autofocus class="w-full" v-tooltip.top="data[field]" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            <Column field="note" :header="$t('vesselSummary.note')" >
                                <template #body="{ data, field }">
                                    <InputText v-model="data[field]" autofocus v-tooltip.top="data[field]" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            <Column field="idRegistryProduct" :header="$t('product.fk')">
                                <template #body="{ data, field }">
                                    <GenericCustomMasterDataAutocompleteV2
                                        :name="field"
                                        v-model="data[field]"
                                        :api="'masterdata/product-combo'" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data.registryProduct  }}</span>
                                </template>
                            </Column>
                            <Column field="idRegistryPlant" :header="$t('registryPlant.fk')">
                                <template #body="{ data, field }">
                                    <GenericCustomMasterDataAutocompleteV2
                                        :name="field"
                                        v-model="data[field]"
                                        :api="'masterdata/registry-plant-combo'" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data.registryPlant  }}</span>
                                </template>
                            </Column>
                            <Column field="laycanString" :header="$t('vesselSummary.laycanString')"/>
                            <Column field="laycanStartDate" :header="$t('laycanStartDate')">
                                <template #body="{ data, field }">
                                    <Calendar 
                                        class="w-full" 
                                        v-model="data[field]" 
                                        dateFormat="dd/mm/yy" 
                                        placeholder="dd/mm/yyyy" v-if="isVoyageEditable(data)"/>
                                        <span v-else>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                </template>
                            </Column>
                            <Column field="laycanEndDate" :header="$t('laycanEndDate')">
                                <template #body="{ data, field }">
                                    <Calendar 
                                        class="w-full" 
                                        v-model="data[field]" 
                                        dateFormat="dd/mm/yy" 
                                        placeholder="dd/mm/yyyy" v-if="isVoyageEditable(data)"/>
                                        <span v-else>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                </template>
                            </Column>
                            <Column field="provisionalQuantityString" :header="$t('vesselSummary.provisionalQuantityString')"/>
                            <Column field="provisionalQuantity" :header="$t('quantity')">
                                <template #body="{ data, field }">
                                    <InputNumber
                                        class="w-full" :minFractionDigits="0" :maxFractionDigits="0"
                                        v-model="data[field]"  v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            <Column field="minProvisionalQuantity" :header="$t('minimumQuantity')">
                                <template #body="{ data, field }">
                                <InputNumber
                                    class="w-full" :minFractionDigits="0" :maxFractionDigits="0"
                                    v-model="data[field]"  v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            <Column field="maxProvisionalQuantity" :header="$t('maximumQuantity')">
                                <template #body="{ data, field }">
                                <InputNumber
                                    class="w-full" :minFractionDigits="0" :maxFractionDigits="0"
                                    v-model="data[field]"  v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            
                            <Column field="pricing" :header="$t('vesselSummary.pricing')" >
                                <template #body="{ data, field }">
                                    <InputText v-model="data[field]" autofocus v-tooltip.top="data[field]" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            
                            <Column field="premium" :header="$t('vesselSummary.premium')" >
                                <template #body="{ data, field }">
                                    <InputText v-model="data[field]" autofocus v-tooltip.top="data[field]" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>

                            <template #groupheader="slotProps">
                                <div class="flex align-items-center gap-2">
                                    <span>{{ slotProps.data.family }}</span>
                                </div>
                            </template>
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="Import">
                        <DataTable :value="data.voyagesImport" scrollable :responsiveLayout="'scroll'" breakpoint="960px" rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                            sortField="movementDirection" :sortOrder="1" :rowClass="rowClass" editMode="cell" @cell-edit-complete="onCellEditComplete" size="small">
                        
                            <Column field="family" :header="$t('vesselSummary.family')">
                                <template #body="{ data, field }">
                                    <span>
                                        {{ data[field] }}
                                        <Tag severity="warning" value="Modified" v-if="data[field + '_dirty']" />
                                    </span>
                                </template>
                            </Column>
                            <Column field="cluster" :header="$t('vesselSummary.cluster')" style="width: 150px;">
                                <template #body="{ data, field }">
                                    <InputText v-model="data[field]" autofocus class="w-full" v-tooltip.top="data[field]" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            <Column field="product" :header="$t('vesselSummary.product')" style="width: 150px;">
                                <template #body="{ data, field }">
                                    <InputText v-model="data[field]" autofocus class="w-full" v-tooltip.top="data[field]" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            <Column field="note" :header="$t('vesselSummary.note')" >
                                <template #body="{ data, field }">
                                    <InputText v-model="data[field]" autofocus v-tooltip.top="data[field]" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            <Column field="idRegistryProduct" :header="$t('product.fk')">
                                <template #body="{ data, field }">
                                    <GenericCustomMasterDataAutocompleteV2
                                        :name="field"
                                        v-model="data[field]"
                                        :api="'masterdata/product-combo'" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data.registryProduct  }}</span>
                                </template>
                            </Column>
                            <Column field="idRegistryPlant" :header="$t('registryPlant.fk')">
                                <template #body="{ data, field }">
                                    <GenericCustomMasterDataAutocompleteV2
                                        :name="field"
                                        v-model="data[field]"
                                        :api="'masterdata/registry-plant-combo'" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data.registryPlant  }}</span>
                                </template>
                            </Column>
                            <Column field="laycanString" :header="$t('vesselSummary.laycanString')"/>
                            <Column field="laycanStartDate" :header="$t('laycanStartDate')">
                                <template #body="{ data, field }">
                                    <Calendar 
                                        class="w-full" 
                                        v-model="data[field]" 
                                        dateFormat="dd/mm/yy" 
                                        placeholder="dd/mm/yyyy" v-if="isVoyageEditable(data)"/>
                                        <span v-else>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                </template>
                            </Column>
                            <Column field="laycanEndDate" :header="$t('laycanEndDate')">
                                <template #body="{ data, field }">
                                    <Calendar 
                                        class="w-full" 
                                        v-model="data[field]" 
                                        dateFormat="dd/mm/yy" 
                                        placeholder="dd/mm/yyyy" v-if="isVoyageEditable(data)"/>
                                        <span v-else>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                </template>
                            </Column>
                            <Column field="provisionalQuantityString" :header="$t('vesselSummary.provisionalQuantityString')"/>
                            <Column field="provisionalQuantity" :header="$t('quantity')">
                                <template #body="{ data, field }">
                                    <InputNumber
                                        class="w-full" :minFractionDigits="0" :maxFractionDigits="0"
                                        v-model="data[field]"  v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            <Column field="minProvisionalQuantity" :header="$t('minimumQuantity')">
                                <template #body="{ data, field }">
                                <InputNumber
                                    class="w-full" :minFractionDigits="0" :maxFractionDigits="0"
                                    v-model="data[field]"  v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            <Column field="maxProvisionalQuantity" :header="$t('maximumQuantity')">
                                <template #body="{ data, field }">
                                <InputNumber
                                    class="w-full" :minFractionDigits="0" :maxFractionDigits="0"
                                    v-model="data[field]"  v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            
                            <Column field="pricing" :header="$t('vesselSummary.pricing')" >
                                <template #body="{ data, field }">
                                    <InputText v-model="data[field]" autofocus v-tooltip.top="data[field]" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>
                            
                            <Column field="premium" :header="$t('vesselSummary.premium')" >
                                <template #body="{ data, field }">
                                    <InputText v-model="data[field]" autofocus v-tooltip.top="data[field]" v-if="isVoyageEditable(data)"/>
                                    <span v-else>{{ data[field]  }}</span>
                                </template>
                            </Column>

                            <template #groupheader="slotProps">
                                <div class="flex align-items-center gap-2">
                                    <span>{{ slotProps.data.family }}</span>
                                </div>
                            </template>
                        </DataTable>
                    </TabPanel>
                </TabView>
            </div>
            
            <div class="col-12" v-if="showVesselSummary">
                <h4>Week {{ vesselSummary?.weekNumber }} - {{ vesselSummary?.year }}</h4>
                <Dropdown v-model="vesselSummarySelectedMonth" :options="vesselSummary?.months" optionValue="monthReference" optionLabel="monthReference" placeholder="Select a Month" class="w-full md:w-14rem">
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex align-items-center">
                            <div>{{  utils.formatMonthYear(new Date(slotProps.value)) }}</div>
                        </div>
                    </template>
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <div>{{ utils.formatMonthYear(new Date(slotProps.option.monthReference)) }}</div>
                        </div>
                    </template>
                </Dropdown>
                <!-- <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" @click="saveVesselSummary" class="p-button-sm p-button-outlined m-1" /> -->
                <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file" class="p-button-sm p-button-outlined m-1" @click="exportVessel"/>
                
                <TabView>
                    <TabPanel header="Export">
                        <div class="grid">
                            <div class="col-12">
                                <DataTable :value="vesselSummaryData.voyagesExport" scrollable rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                                    sortField="movementDirection" :sortOrder="1" :rowClass="rowClass" editMode="cell" @cell-edit-complete="onCellEditComplete" size="small">
                                    <Column field="family" :header="$t('vesselSummary.family')">
                                        <template #body="{ data, field }">
                                            <span>
                                                {{ data[field] }}
                                                <Tag severity="warning" value="Modified" v-if="data[field + '_dirty']" />
                                            </span>
                                        </template>
                                    </Column>

                                    <Column field="voyageNumber" :header="$t('movementInstructions.voyageNumber')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span v-if="data.idMovementInstructionHeader">{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="idRegistryProduct" :header="$t('product.fk')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data.registryProduct : data.movementInstructionRegistryProduct  }}</span> -->
                                            <span>{{ data.registryProduct }}</span> 
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data.idRegistryProduct != data.movementInstructionIdRegistryProduct" v-tooltip="data.movementInstructionRegistryProduct">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>

                                    <Column field="registryVessel" :header="$t('vessel.fk')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="idRegistryPlant" :header="$t('registryPlant.fk')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data.registryPlant : data.movementInstructionRegistryPlant  }}</span> -->
                                            <span>{{ data.registryPlant  }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data.registryPlant != data.movementInstructionRegistryPlant" v-tooltip="data.movementInstructionRegistryPlant">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="laycanStartDate" :header="$t('laycanStartDate')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{data.movementInstructionLaycanStartDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate)) : utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate))}}</span> -->
                                            <span>{{utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate))}}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate)) != utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate))" v-tooltip="utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="laycanEndDate" :header="$t('laycanEndDate')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{data.movementInstructionLaycanEndDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate)) : utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate))}}</span> -->
                                            <span>{{utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate)) }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate)) != utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate))" v-tooltip="utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>

                                    <Column field="provisionalQuantity" :header="$t('quantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionQuantity  }}</span> -->
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionQuantity" v-tooltip="data.movementInstructionQuantity + ''">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="provisionalMinimumQuantity" :header="$t('minimumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionMinimumQuantity  }}</span> -->
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionMinimumQuantity" v-tooltip="data.movementInstructionMinimumQuantity + ''">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="provisionalMaximumQuantity" :header="$t('maximumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionMaximumQuantity  }}</span> -->
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionMaximumQuantity" v-tooltip="data.movementInstructionMaximumQuantity + ''">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>


                                    <Column field="registryInspector" :header="$t('inspector.fk')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>
                                    <Column field="norDate" :header="$t('vesselSummary.norDate')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>
                                    </Column>
                                    <Column field="mooringDate" :header="$t('vesselSummary.mooringDate')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>
                                    </Column>

                                    <Column field="incotermCode" :header="$t('incoterm.fk')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="pricing" :header="$t('vesselSummary.pricing')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="premium" :header="$t('vesselSummary.premium')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="note" :header="$t('vesselSummary.note')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <template #groupheader="slotProps">
                                        <div class="flex align-items-center gap-2">
                                            <span>{{ slotProps.data.family }}</span>
                                        </div>
                                    </template>
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Import">
                        <DataTable :value="vesselSummaryData.voyagesImport" scrollable :responsiveLayout="'scroll'" breakpoint="960px" rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                            sortField="movementDirection" :sortOrder="1" :rowClass="rowClass" editMode="cell" @cell-edit-complete="onCellEditComplete" size="small">

                                
                            <Column field="family" :header="$t('vesselSummary.family')">
                                        <template #body="{ data, field }">
                                            <span>
                                                {{ data[field] }}
                                                <Tag severity="warning" value="Modified" v-if="data[field + '_dirty']" />
                                            </span>
                                        </template>
                                    </Column>

                                    <Column field="voyageNumber" :header="$t('movementInstructions.voyageNumber')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span v-if="data.idMovementInstructionHeader">{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="idRegistryProduct" :header="$t('product.fk')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data.registryProduct : data.movementInstructionRegistryProduct  }}</span> -->
                                            <span>{{ data.registryProduct }}</span> 
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data.idRegistryProduct != data.movementInstructionIdRegistryProduct" v-tooltip="data.movementInstructionRegistryProduct">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>

                                    <Column field="registryVessel" :header="$t('vessel.fk')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="idRegistryPlant" :header="$t('registryPlant.fk')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data.registryPlant : data.movementInstructionRegistryPlant  }}</span> -->
                                            <span>{{ data.registryPlant  }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data.registryPlant != data.movementInstructionRegistryPlant" v-tooltip="data.movementInstructionRegistryPlant">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="laycanStartDate" :header="$t('laycanStartDate')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{data.movementInstructionLaycanStartDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate)) : utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate))}}</span> -->
                                            <span>{{utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate))}}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate)) != utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate))" v-tooltip="utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="laycanEndDate" :header="$t('laycanEndDate')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{data.movementInstructionLaycanEndDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate)) : utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate))}}</span> -->
                                            <span>{{utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate)) }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate)) != utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate))" v-tooltip="utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>

                                    <Column field="provisionalQuantity" :header="$t('quantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionQuantity  }}</span> -->
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionQuantity" v-tooltip="data.movementInstructionQuantity + ''">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="provisionalMinimumQuantity" :header="$t('minimumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionMinimumQuantity  }}</span> -->
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionMinimumQuantity" v-tooltip="data.movementInstructionMinimumQuantity + ''">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="provisionalMaximumQuantity" :header="$t('maximumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionMaximumQuantity  }}</span> -->
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionMaximumQuantity" v-tooltip="data.movementInstructionMaximumQuantity + ''">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>


                                    <Column field="registryInspector" :header="$t('inspector.fk')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>
                                    <Column field="norDate" :header="$t('vesselSummary.norDate')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>
                                    </Column>
                                    <Column field="mooringDate" :header="$t('vesselSummary.mooringDate')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>
                                    </Column>

                                    <Column field="incotermCode" :header="$t('incoterm.fk')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="pricing" :header="$t('vesselSummary.pricing')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="premium" :header="$t('vesselSummary.premium')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="note" :header="$t('vesselSummary.note')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <template #groupheader="slotProps">
                                        <div class="flex align-items-center gap-2">
                                            <span>{{ slotProps.data.family }}</span>
                                        </div>
                                    </template>
                        </DataTable>
                    </TabPanel>
                </TabView>
            </div>

            <div class="col-12" v-if="showVoyages">
                <Dropdown v-model="voyagesSelectedMonth" :options="voyages" optionValue="monthReference" optionLabel="monthReference" placeholder="Select a Month" class="w-full md:w-14rem">
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex align-items-center">
                            <div>{{  utils.formatMonthYear(new Date(slotProps.value)) }}</div>
                        </div>
                    </template>
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <div>{{ utils.formatMonthYear(new Date(slotProps.option.monthReference)) }}</div>
                        </div>
                    </template>
                </Dropdown>
                <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file" class="p-button-sm p-button-outlined m-1" @click="exportVesselByDate"/>
                <ResponsiveButton :label="$t('btn.publish')" icon="pi pi-file" class="p-button-sm p-button-outlined m-1" @click="publishVessel"
                v-if="!uiPermissions('VesselSummaryPublish').isHidden"/>
                
                <TabView>
                    <TabPanel header="Export">
                        <div class="grid">
                            <div class="col-12" style="height: calc(75vh)" >
                                <DataTable :value="vesselSummaryData.voyagesExport" scrollable rowGroupMode="subheader" groupRowsBy="family" sortMode="single" scrollHeight="flex" responsiveLayout="stack" 
                                    sortField="movementDirection" :sortOrder="1" :rowClass="rowClass" editMode="cell" @cell-edit-complete="onCellEditComplete" size="small">
                                
                                    <Column field="family" :header="$t('vesselSummary.family')">
                                        <template #body="{ data, field }">
                                            <span>
                                                {{ data[field] }}
                                                <Tag severity="warning" value="Modified" v-if="data[field + '_dirty']" />
                                            </span>
                                        </template>
                                    </Column>

                                    
                                    <Column class="button-column" :exportable="false" :reorderableColumn="false">
                                        <template #body="slotProps">
                                            <Button v-tooltip="$t('vesselSummary.changeStatusBtn')" icon="fa-solid fa-right-left" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" 
                                            size="small" @click="openChangeStatus(slotProps.data)" v-if="!uiPermissions('ChangeVoyageStatusButton').isHidden" />

                                            <Button v-tooltip="$t('vesselSummary.alignActualInfo')" icon="fa-solid fa-rotate" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" 
                                            size="small" @click="alignActualInfo(slotProps.data)" v-if="!uiPermissions('alignActualInfoButton').isHidden && showAlignInfoButton(slotProps.data)" />
                                        </template>
                                    </Column>

                                    <Column field="voyageNumber" :header="$t('movementInstructions.voyageNumber')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span v-if="data.idMovementInstructionHeader">{{ data[field]  }}</span>
                                            <span><ResponsiveButton :label="$t('btn.link')" style="background-color: white;" icon="pi pi-link" @click="openLinkMovementInstructionsSaved(data)" class="p-button-sm p-button-outlined m-1" 
                                                v-if="!uiPermissions('LinkVesselSummaryMovementInstructionBtn').isHidden"/></span>
                                        </template>
                                    </Column>

                                    <Column header="Status" style="width: 150px;">
                                        <template #body="{ data }">
                                            <Tag style="font-size: 10px" :value="getStatusLabel(data)" :severity="getStatusSeverity(data)" />
                                        </template>
                                    </Column>

                                    <Column field="idRegistryProduct" :header="$t('product.fk')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data.registryProduct : data.movementInstructionRegistryProduct  }}</span> -->
                                            <span>{{ data.registryProduct }}</span> 
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data.idRegistryProduct != data.movementInstructionIdRegistryProduct" v-tooltip="data.movementInstructionRegistryProduct">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    
                                    <Column field="registryVessel" :header="$t('vessel.fk')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="idRegistryPlant" :header="$t('registryPlant.fk')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data.registryPlant : data.movementInstructionRegistryPlant  }}</span> -->
                                            <span>{{ data.registryPlant  }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data.registryPlant != data.movementInstructionRegistryPlant" v-tooltip="data.movementInstructionRegistryPlant">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="laycanStartDate" :header="$t('laycanStartDate')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{data.movementInstructionLaycanStartDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate)) : utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate))}}</span> -->
                                            <span>{{utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate))}}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate)) != utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate))" v-tooltip="utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="laycanEndDate" :header="$t('laycanEndDate')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <!-- <span>{{data.movementInstructionLaycanEndDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate)) : utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate))}}</span> -->
                                            <span>{{utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate)) }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate)) != utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate))" v-tooltip="utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('vesselSummary.operationaLaycan')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ formatLaycan(data) }}
                                            <ResponsiveButton :label="$t('btn.edit')" style="background-color: white;" icon="pi pi-pencil" class="p-button-sm p-button-outlined m-1" @click="openUpdateOperationalLaycan(data)" v-if="!uiPermissions('UpdateOperationalLaycan').isHidden"/>
                                        </template>
                                    </Column>
                                    <Column field="provisionalQuantity" :header="$t('quantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data.actualQuantity ? utils.formatDecimal(data.actualQuantity,3) : utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionQuantity" v-tooltip="data.movementInstructionQuantity + ''">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="provisionalMinimumQuantity" :header="$t('minimumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionMinimumQuantity  }}</span> -->
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionMinimumQuantity" v-tooltip="data.movementInstructionMinimumQuantity + ''">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="provisionalMaximumQuantity" :header="$t('maximumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionMaximumQuantity  }}</span> -->
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionMaximumQuantity" v-tooltip="data.movementInstructionMaximumQuantity + ''">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>
                                    

                                    <Column field="registryInspector" :header="$t('inspector.fk')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>
                                    <Column field="norDate" :header="$t('vesselSummary.norDate')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>
                                    </Column>
                                    <Column field="mooringDate" :header="$t('vesselSummary.mooringDate')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>
                                    </Column>

                                    <Column field="incotermCode" :header="$t('incoterm.fk')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>
                                    
                                    <Column field="pricing" :header="$t('vesselSummary.pricing')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>
                                    
                                    <Column field="premium" :header="$t('vesselSummary.premium')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <Column field="note" :header="$t('vesselSummary.note')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ data[field]  }}</span>
                                        </template>
                                    </Column>

                                    <template #groupheader="slotProps">
                                        <div class="flex align-items-center gap-2">
                                            <span>{{ slotProps.data.family }}</span>
                                        </div>
                                    </template>
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Import">
                        <div class="grid">
                            <div class="col-12"  style="height: calc(75vh)" >

                                <DataTable :value="vesselSummaryData.voyagesImport" scrollable breakpoint="960px" rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                                    scrollHeight="flex" responsiveLayout="stack" sortField="movementDirection" :sortOrder="1" :rowClass="rowClass" editMode="cell" @cell-edit-complete="onCellEditComplete" size="small">
                                
                                <Column field="family" :header="$t('vesselSummary.family')">
                                    <template #body="{ data, field }">
                                        <span>
                                            {{ data[field] }}
                                            <Tag severity="warning" value="Modified" v-if="data[field + '_dirty']" />
                                        </span>
                                    </template>
                                </Column>
                                <Column class="button-column" :exportable="false" :reorderableColumn="false">
                                    <template #body="slotProps">
                                        <Button v-tooltip="$t('vesselSummary.changeStatusBtn')" icon="fa-solid fa-right-left" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" 
                                        size="small" @click="openChangeStatus(slotProps.data)" v-if="!uiPermissions('ChangeVoyageStatusButton').isHidden" />

                                        <Button v-tooltip="$t('vesselSummary.alignActualInfo')" icon="fa-solid fa-rotate" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" 
                                        size="small" @click="alignActualInfo(slotProps.data)" v-if="!uiPermissions('alignActualInfoButton').isHidden && showAlignInfoButton(slotProps.data)" />
                                    </template>
                                </Column>

                                <Column field="voyageNumber" :header="$t('movementInstructions.voyageNumber')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <span v-if="data.idMovementInstructionHeader">{{ data[field]  }}</span>
                                        <span><ResponsiveButton :label="$t('btn.link')" style="background-color: white;" icon="pi pi-link" @click="openLinkMovementInstructionsSaved(data)" class="p-button-sm p-button-outlined m-1" 
                                            v-if="!uiPermissions('LinkVesselSummaryMovementInstructionBtn').isHidden" /></span>
                                    </template>
                                </Column>

                                <Column header="Status" style="width: 150px;">
                                    <template #body="{ data }">
                                        <Tag style="font-size: 10px" :value="getStatusLabel(data)" :severity="getStatusSeverity(data)" />
                                    </template>
                                </Column>

                                <Column field="idRegistryProduct" :header="$t('product.fk')" style="width: 150px;">
                                    <template #body="{ data }">
                                        <!-- <span>{{ !data.idMovementInstructionHeader ? data.registryProduct : data.movementInstructionRegistryProduct  }}</span> -->
                                        <span>{{ data.registryProduct }}</span> 
                                        <span class="warning" v-if="data.idMovementInstructionHeader && data.idRegistryProduct != data.movementInstructionIdRegistryProduct" v-tooltip="data.movementInstructionRegistryProduct">
                                            <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                        </span>
                                    </template>
                                </Column>
                                
                                <Column field="registryVessel" :header="$t('vessel.fk')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <span>{{ data[field]  }}</span>
                                    </template>
                                </Column>

                                <Column field="idRegistryPlant" :header="$t('registryPlant.fk')" style="width: 150px;">
                                    <template #body="{ data }">
                                        <!-- <span>{{ !data.idMovementInstructionHeader ? data.registryPlant : data.movementInstructionRegistryPlant  }}</span> -->
                                        <span>{{ data.registryPlant  }}</span>
                                        <span class="warning" v-if="data.idMovementInstructionHeader && data.registryPlant != data.movementInstructionRegistryPlant" v-tooltip="data.movementInstructionRegistryPlant">
                                            <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                        </span>
                                    </template>
                                </Column>
                                <Column field="laycanStartDate" :header="$t('laycanStartDate')" style="width: 150px;">
                                    <template #body="{ data }">
                                        <!-- <span>{{data.movementInstructionLaycanStartDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate)) : utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate))}}</span> -->
                                        <span>{{utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate))}}</span>
                                        <span class="warning" v-if="data.idMovementInstructionHeader && utils.formatDate(utils.dateToCurrentTimeZone(data.laycanStartDate)) != utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate))" v-tooltip="utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanStartDate))">
                                            <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                        </span>
                                    </template>
                                </Column>
                                <Column field="laycanEndDate" :header="$t('laycanEndDate')" style="width: 150px;">
                                    <template #body="{ data }">
                                        <!-- <span>{{data.movementInstructionLaycanEndDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate)) : utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate))}}</span> -->
                                        <span>{{utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate)) }}</span>
                                        <span class="warning" v-if="data.idMovementInstructionHeader && utils.formatDate(utils.dateToCurrentTimeZone(data.laycanEndDate)) != utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate))" v-tooltip="utils.formatDate(utils.dateToCurrentTimeZone(data.movementInstructionLaycanEndDate))">
                                            <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                        </span>
                                    </template>
                                </Column>
                                <Column :header="$t('vesselSummary.operationaLaycan')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ formatLaycan(data) }}
                                            <ResponsiveButton :label="$t('btn.edit')" style="background-color: white;" icon="pi pi-pencil" class="p-button-sm p-button-outlined m-1" @click="openUpdateOperationalLaycan(data)" v-if="!uiPermissions('UpdateOperationalLaycan').isHidden"/>
                                        </template>
                                    </Column>
                                <Column field="provisionalQuantity" :header="$t('quantity')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionQuantity  }}</span> -->
                                        <span>{{ data.actualQuantity ? utils.formatDecimal(data.actualQuantity,3) : utils.formatInteger(data[field]) }}</span>
                                        <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionQuantity" v-tooltip="data.movementInstructionQuantity + ''">
                                            <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                        </span>
                                    </template>
                                </Column>
                                <Column field="provisionalMinimumQuantity" :header="$t('minimumQuantity')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionMinimumQuantity  }}</span> -->
                                        <span>{{ utils.formatInteger(data[field]) }}</span>
                                        <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionMinimumQuantity" v-tooltip="data.movementInstructionMinimumQuantity + ''">
                                            <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                        </span>
                                    </template>
                                </Column>
                                <Column field="provisionalMaximumQuantity" :header="$t('maximumQuantity')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <!-- <span>{{ !data.idMovementInstructionHeader ? data[field] : data.movementInstructionMaximumQuantity  }}</span> -->
                                        <span>{{ utils.formatInteger(data[field]) }}</span>
                                        <span class="warning" v-if="data.idMovementInstructionHeader && data[field] != data.movementInstructionMaximumQuantity" v-tooltip="data.movementInstructionMaximumQuantity + ''">
                                            <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                        </span>
                                    </template>
                                </Column>
                                

                                <Column field="registryInspector" :header="$t('inspector.fk')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <span>{{ data[field]  }}</span>
                                    </template>
                                </Column>
                                <Column field="norDate" :header="$t('vesselSummary.norDate')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                    </template>
                                </Column>
                                <Column field="mooringDate" :header="$t('vesselSummary.mooringDate')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                    </template>
                                </Column>

                                <Column field="incotermCode" :header="$t('incoterm.fk')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <span>{{ data[field]  }}</span>
                                    </template>
                                </Column>
                                
                                <Column field="pricing" :header="$t('vesselSummary.pricing')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <span>{{ data[field]  }}</span>
                                    </template>
                                </Column>
                                
                                <Column field="premium" :header="$t('vesselSummary.premium')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <span>{{ data[field]  }}</span>
                                    </template>
                                </Column>

                                <Column field="note" :header="$t('vesselSummary.note')" style="width: 150px;">
                                    <template #body="{ data, field }">
                                        <span>{{ data[field]  }}</span>
                                    </template>
                                </Column>

                                <template #groupheader="slotProps">
                                    <div class="flex align-items-center gap-2">
                                        <span>{{ slotProps.data.family }}</span>
                                    </div>
                                </template>
                        </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                </TabView>
            </div>

        </div>
    </main>
</template>
        
<style>

    .import-info {
        color: steelblue;
        font-size: 1.5rem;
    }

    .p-rowgroup-header{
        background-color: gray !important;
        color: white !important;
    }

    .bg-confirmed {
        background-color: #87d37c !important;
    }
    .bg-not-confirmed {
        background-color: #f9bf3b !important;
    }
    .bg-deleted{
        background-color: #c0392b !important;
        color: white !important;
    }
</style>